/**
 * Decodifica caracteres especiales y entidades HTML en texto.
 * Convierte caracteres codificados como @ o &aacute; a sus equivalentes UTF-8.
 * 
 * @param {string} text - Texto con posibles caracteres codificados.
 * @returns {string} Texto decodificado con caracteres especiales correctos.
 */
export const decodeSpecialCharacters = (text) => {
  if (!text) return '';
  

  
  // Crear un elemento temporal para decodificar entidades HTML
  const textarea = document.createElement('textarea');
  textarea.innerHTML = text;
  let decoded = textarea.value;
  
  // Decodificar caracteres especiales comunes
  const replacements = {
    // Entidades HTML nombradas
    '&aacute;': 'á', '&eacute;': 'é', '&iacute;': 'í', '&oacute;': 'ó', '&uacute;': 'ú',
    '&Aacute;': 'Á', '&Eacute;': 'É', '&Iacute;': 'Í', '&Oacute;': 'Ó', '&Uacute;': 'Ú',
    '&ntilde;': 'ñ', '&Ntilde;': 'Ñ',
    '&uuml;': 'ü', '&Uuml;': 'Ü',
    '&ccedil;': 'ç', '&Ccedil;': 'Ç',
    
    // Entidades HTML numéricas
    '&#225;': 'á', '&#233;': 'é', '&#237;': 'í', '&#243;': 'ó', '&#250;': 'ú',
    '&#193;': 'Á', '&#201;': 'É', '&#205;': 'Í', '&#211;': 'Ó', '&#218;': 'Ú',
    '&#241;': 'ñ', '&#209;': 'Ñ',
    '&#252;': 'ü', '&#220;': 'Ü',
    
    // Casos específicos problemáticos para ñ
    'ñ': 'ñ', // UTF-8 mal codificado común
    'Ñ': 'Ñ', // UTF-8 mal codificado común
    'n~': 'ñ', // Codificación alternativa
    'N~': 'Ñ', // Codificación alternativa
    '\\u00f1': 'ñ', // Unicode escape
    '\\u00d1': 'Ñ', // Unicode escape
    '%C3%B1': 'ñ', // URL encoding
    '%C3%91': 'Ñ', // URL encoding
    '@': 'á', // Caso específico mencionado
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };
  
  // UTF-8 mal codificado - usando códigos de caracteres
  const utfReplacements = [
    [/Ã¡/g, 'á'], [/Ã©/g, 'é'], [/Ã­/g, 'í'], [/Ã³/g, 'ó'], [/Ãº/g, 'ú'], [/Ã±/g, 'ñ'],
    [/Ã /g, 'Á'], [/Ã‰/g, 'É'], [/Ã /g, 'Í'], [/Ã"/g, 'Ó'], [/Ãš/g, 'Ú'], [/Ã'/g, 'Ñ'],
    [/Ã¼/g, 'ü'], [/Ãœ/g, 'Ü'], [/Ã§/g, 'ç'], [/Ã‡/g, 'Ç'],
    // Patrones adicionales para ñ
    [/Ã±/g, 'ñ'], // Doble codificación UTF-8
    [/Ã/g, 'Ñ'], // Doble codificación UTF-8 mayúscula
    [/\\u00f1/g, 'ñ'], // Unicode escape literal
    [/\\u00d1/g, 'Ñ'], // Unicode escape literal mayúscula
    [/ñ/g, 'ñ'], // Caracteres raros que pueden aparecer
    [/Ñ/g, 'Ñ'] // Caracteres raros que pueden aparecer mayúscula
  ];
  
  // Aplicar reemplazos básicos
  Object.entries(replacements).forEach(([encoded, decodedChar]) => {
    const escapedEncoded = encoded.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    decoded = decoded.replace(new RegExp(escapedEncoded, 'g'), decodedChar);
  });
  
  // Aplicar reemplazos UTF-8
  utfReplacements.forEach(([regex, replacement]) => {
    decoded = decoded.replace(regex, replacement);
  });
  
  // Decodificación adicional para casos específicos de workspace
  try {
    // Intentar decodificar como URI component si contiene %
    if (decoded.includes('%')) {
      decoded = decodeURIComponent(decoded);
    }
    
    // Normalizar caracteres Unicode
    decoded = decoded.normalize('NFC');
  } catch (e) {
    // Si falla la decodificación, continuar con el texto actual
    console.warn('Error en decodificación adicional:', e);
  }
  
  return decoded;
};

/**
 * Formatea descripción HTML removiendo tags y decodificando caracteres.
 * Convierte HTML a texto plano manteniendo saltos de línea.
 * 
 * @param {string} htmlString - String HTML con posibles tags y caracteres codificados.
 * @returns {string} Texto plano formateado con caracteres decodificados.
 */
export const formatDescription = (htmlString) => {
  if (!htmlString) return '';
  
  let formatted = htmlString
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<b>(.*?)<\/b>/gi, '$1')
    .replace(/<[^>]*>/g, '')
    .trim();
    
  return decodeSpecialCharacters(formatted);
};